import type { Topic } from '@/types';

export const topics: Topic[] = [
  {
    id: 'topic-plot',
    title: '《玉女心经2》全片时间线与伏笔梳理',
    desc: '从竹林闭关到玄阴总坛，一条时间线看懂全片暗埋的七处伏笔与三次呼应。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20poster%20illustration%20of%20an%20unfurling%20ancient%20scroll%20timeline%20with%20jade%20green%20and%20cream%20tones%20and%20warm%20orange%20markers%2C%20subtle%20bamboo%20silhouettes%20in%20the%20background%2C%20refined%20minimal%20Chinese%20design%2C%20soft%20film%20grain%2C%20clean%20negative%20space&width=800&height=500&seq=topic-plot&orientation=landscape',
    tag: '剧情解析',
    count: 24,
  },
  {
    id: 'topic-character',
    title: '角色深入分析：玉女与沈司白的情感弧线',
    desc: '从试探、并肩到托付，拆解两位主角在每个关键节点的关系变化与动机。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20two%20ancient%20Chinese%20figures%20standing%20apart%20in%20jade%20green%20and%20cream%20robes%20under%20a%20soft%20orange%20sunset%2C%20subtle%20connection%20line%20between%20them%2C%20refined%20minimal%20design%2C%20soft%20film%20grain%2C%20harmonious%20composition&width=800&height=500&seq=topic-character&orientation=landscape',
    tag: '角色分析',
    count: 18,
  },
  {
    id: 'topic-world',
    title: '江湖世界观：师门与门派考据笔记',
    desc: '梳理《玉女心经》系列里的师承关系、门派立场与关键信物，读懂背后格局。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20an%20ancient%20Chinese%20sect%20map%20with%20temple%20silhouettes%20and%20connecting%20paths%20in%20dark%20green%20and%20cream%20tones%2C%20warm%20orange%20seals%2C%20refined%20minimal%20design%2C%20soft%20film%20grain%2C%20clean%20composition&width=800&height=500&seq=topic-world&orientation=landscape',
    tag: '背景资料',
    count: 15,
  },
  {
    id: 'topic-aesthetic',
    title: '东方美学：武侠影像里的配色与构图',
    desc: '墨绿、米白与橘红如何构建出东方韵味？一篇讲透本系列的影像设计语言。',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20color%20palette%20swatch%20inspired%20by%20Chinese%20painting%2C%20jade%20green%20cream%20and%20warm%20orange%20blocks%20with%20subtle%20mountain%20line%20art%2C%20refined%20minimal%20design%2C%20soft%20film%20grain%2C%20harmonious%20negative%20space&width=800&height=500&seq=topic-aesthetic&orientation=landscape',
    tag: '影像美学',
    count: 12,
  },
];